"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataGridEnterprise = exports.setDataGridEnterpriseLicense = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DataGrid_1 = require("../../components/DataGrid/DataGrid");
require("ag-grid-enterprise");
var ag_grid_enterprise_1 = require("ag-grid-enterprise");
var setDataGridEnterpriseLicense = function (key) {
  //@ts-ignore
  if (!window.ignoreAgGridLicenseKey) {
    ag_grid_enterprise_1.LicenseManager.setLicenseKey(key);
  }
};
exports.setDataGridEnterpriseLicense = setDataGridEnterpriseLicense;
var DataGridEnterprise = function (props) {
  (0, exports.setDataGridEnterpriseLicense)(props.licenseKey);
  return (0, jsx_runtime_1.jsx)(DataGrid_1.DataGrid, __assign({
    sideBar: {
      toolPanels: [{
        id: "id",
        labelDefault: "Columns",
        labelKey: "labelKey",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressPivotMode: true,
          suppressValues: true,
          suppressRowGroups: true
        }
      }]
    }
  }, props, {
    __enterprise__: true
  }));
};
exports.DataGridEnterprise = DataGridEnterprise;